<template lang="pug">
FcwShowcaseHelpTemplate(
  :sharing-faq-item-ids="showcaseHelpData.sharingFaqItemIds"
  :leasing-faq-item-ids="showcaseHelpData.leasingFaqItemIds"
)
</template>

<script lang="ts" setup>
definePageMeta({
  layout: 'showcase',
  navPlainThreshold: 0,
});

const { data: showcaseHelpData, seoData, error } = await useCmsShowcaseHelp();
useCmsError(error);

useClientSeoMeta(seoData);
</script>
